import { render } from "./SelectIcon.vue?vue&type=template&id=13b71601&scoped=true"
import script from "./SelectIcon.vue?vue&type=script&lang=js"
export * from "./SelectIcon.vue?vue&type=script&lang=js"

import "./SelectIcon.vue?vue&type=style&index=0&id=13b71601&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b71601"]])

export default __exports__